import { FILE_MANAGER_CONSTANTS } from './file-manager'

export const ERROR_MESSAGES = {
  // General errors
  GENERAL_ERROR: 'An error occurred',
  NOT_FOUND: 'Not Found',
  RESOURCE_NOT_FOUND: 'Resource not found',
  SOMETHING_WENT_WRONG: 'Something Went Wrong',
  SOMETHING_WENT_WRONG_TRY_AGAIN:
    'Something Went Wrong, Please try again later',

  // Add Line Item related errors
  ITEMIZED_DEDUCTION_EXCEEDED:
    'Itemized deduction value should be less than or equal to deduction amount.',
  PROMOTION_DATES_REQUIRED:
    'Please select promotion start and end dates under invoice details',
  FILL_CREATE_LINE_ITEMS: 'Please fill the create line items',
  INVOICE_LINEITEM_SELECT_REQUIRED:
    'At least one invoice line item must be selected to assign a Deduction Type',
  FAILED_TO_DELETE_FILE: 'Failed to delete the file.',
  SELECT_DOCUMENT_TYPE: 'Please select document type',
  DISPUTE_AMOUNT_EXCEEDS_APPROVED:
    'Dispute Amount should not be greater than approved amount',
  FAILED_TO_LOAD_DOCUMENT_TYPES:
    'Failed to load document types. Please try again.',
  DOWNLOAD_URL_NOT_AVAILABLE:
    'Download URL not available. Please try again later.',

  // Export related errors
  EXPORT_LIMIT_EXCEEDED:
    'Export cannot exceed 15,000 records. Please apply filters to reduce the record count.',
  SELECT_COLUMNS_FOR_EXPORT:
    'Please select at least one column to export the data',
  SELECT_ATLEAST_ONE_COLUMN_EXPORT:
    'Please select atleast one column to export the data',
  UNABLE_TO_EDIT_DOCUMENT: 'Unable to edit this document.',
  FAILED_TO_EXPORT_SUMMARY_DATA: 'Failed to export summary data',

  // File upload errors
  ONLY_CSV_FILES_ALLOWED: 'Only CSV files are allowed',
  MAX_ROWS_REACHED: 'Max allowed rows reached',
  FILE_UPLOAD_ERROR: 'Error in file uploading',
  FILE_UPLOAD_FAILED: 'Failed to upload files',
  SELECT_FILE: 'Please select a file',
  SELECT_AT_LEAST_ONE_FILE: 'Please select at least one file',
  NO_FILES_PROVIDED: 'No files provided',
  MISMATCH_FILES_AND_URLS: 'Mismatch in number of files and signed URLs',
  FAILED_TO_GENERATE_SIGNED_URLS: 'Failed to generate Signed URLs',
  FILE_SIZE_LIMIT_EXCEEDED:
    'File size exceeds the maximum limit ' +
    FILE_MANAGER_CONSTANTS.MAX_UPLOAD_FILE_MB +
    ' MB',
  MULTIPLE_FILES_NOT_ALLOWED: 'Multiple files not allowed',
  UNABLE_TO_PREVIEW: 'Unable to preview',
  FILE_TYPE_NOT_PERMITTED: 'This file type is not permitted',
  INVALID_CSV_FILE: 'Invalid csv file',

  // Invoice related errors
  SELECT_INVOICE_TO_PROCEED: 'Please select a Invoice to proceed',
  SELECT_AT_LEAST_ONE_INVOICE: 'Please select at least one Invoice',
  SELECT_INVOICE_TO_GENERATE_REPORT:
    'Please select any Invoice to Generate report',
  INVOICES_MANDATORY: 'Invoices is mandatory',
  MULTIPLE_INVOICES_NOT_ALLOWED: 'Multiple invoice selection is not allowed',
  MULTIPLE_INVOICES_SPLIT_NOT_ALLOWED:
    ' Please select an invoice for split. Multiple invoice selection is not allowed',
  MULTIPLE_INVOICES_REVERT_NOT_ALLOWED:
    'Please select an invoice for revert. Multiple invoice selection is not allowed',
  MULTIPLE_INVOICE_NOT_ALLOWED: 'Multiple Invoice not allowed',
  LEVEL_3_DATA_EXISTS: 'Selected invoice has Level-3 data',
  ZERO_PROMO_GAP_AMOUNT:
    'The following invoice(s) have zero Promo Gap Amount and cannot link promotion:',
  SUM_OF_DEDUCTIONS_MUST_EQUAL_TOTAL:
    'sum of deductions for splits has to equal total deductions',

  // Payment related errors
  SELECT_PAYMENT_ID: 'Please select a Payment Id',
  MULTIPLE_CUSTOMERS_NOT_ALLOWED: 'Multiple customers not allowed',

  // Dispute related errors
  UPDATE_DISPUTE_STATUS: 'Please update the dispute status',
  MULTIPLE_CUSTOMERS_SELECTED:
    'Multiple customers are selected. Please select only deductions for one customer to dispute in bulk.',
  POSITIVE_AMOUNT_CANNOT_BE_DISPUTED: 'Positive Amount cannot be disputed',
  UNLINK_INVOICES_CANCEL_PROMOTION:
    'Please Unlink the invoices and cancel the promotion',
  SPLIT_NOT_ALLOWED_FOR_DISPUTED:
    'Split is not allowed for Disputed invoices. Kindly change the processing status to be able to perform split',

  // Promotion related errors
  PROMOTION_DEDUCTION_RESOLVED:
    'Promotion Cannot be applied to this deduction as the deduction amount is already resolved',
  AMOUNT_GREATER_THAN_DEDUCTION:
    "Amount Can't be greater than deduction amount",
  PROMOTION_OVERUTILIZED: 'The promotion is overutilized',
  SELECT_UNLINKED_PROMOTIONS: 'please select unlinked promotions to link',
  PROMOTION_END_DATE_GREATER:
    'Promotion end date must be greater or equal to Promotion start date',
  PROMOTION_START_DATE_LESSER:
    'Promotion start date must be lesser or equal to Promotion end date',
  INVALID_PROMOTION_START_DATES: 'Please enter valid promotion start dates',
  INVALID_PROMOTION_END_DATES: 'Please enter valid promotion end dates',
  FAILED_TO_LINK_PROMOTION: 'Failed to link promotion',
  PROMOTION_ONLY_FOR_DEDUCTION: 'Promotion Can only be Applied to Deduction',

  // Form validation errors
  REQUIRED_FIELD: 'This field is required',
  FILL_ALL_REQUIRED_FIELDS: 'Please fill all the required fields',
  INVALID_FORMAT: 'Invalid format',
  INVALID_DATE_RANGE: 'Invalid date range',
  SEARCH_VALUE_CANNOT_BE_EMPTY: 'Search value cannot be empty',
  VALUE_FORMAT_REQUIRED: 'The value must be in this format 10,50',
  DEBIT_DOCUMENT_NUMBER_MANDATORY: 'Debit Document Number is mandatory',
  ORIGINAL_AMOUNT_MANDATORY: 'Original amount is mandatory',
  PAYMENT_NUMBER_MANDATORY: 'Payment Number is mandatory',
  GAP_SHOULD_BE_ZERO: 'The Gap should be 0',

  // Payment Date validation errors
  PAYMENT_DATE_LESSER_THAN_DISPUTE_DATE:
    'Payment date must be greater or equal to Dispute date',
  INVALID_PAYMENT_DATES: 'Please enter valid payment dates',
  DISPUTE_DATE_MISSING:
    'Payment date can only be updated for disputed invoices',
}

export const TITLE_TYPES = {
  ERROR: 'Error',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  VALIDATION: 'Validation',
  NONE: '', // For cases where no error type label is needed
}

export const SUCCESS_MESSAGES = {
  INVOICE_UPDATED_SUCCESSFULLY: 'Invoice has been updated successfully',
  FILE_UPLOADED_SUCCESSFULLY: 'File has been uploaded successfully',
  PROMOTION_UPDATED_SUCCESSFULLY: 'Promotion has been updated successfully',
  REPORT_DOWNLOADED_SUCCESSFULLY: 'Report Downloaded Successfully',
  PROMOTION_LINKED_SUCCESSFULLY: 'Promotion linked successfully',
  FILE_DOWNLOADED_SUCCESSFULLY: 'File downloaded successfully',
  REPORT_EXPORTED_SUCCESSFULLY: 'Report Exported Successfully',
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
}
